import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const TransportationList = () => {
  const [filters, setFilters] = useState({
    school_id: "",
    class_id: "",
    vendor_id: "",
    member_id: "",
    is_delivered: ""
  });

  const navigate = useNavigate();
  const userTypeId = Number(localStorage.getItem("userTypeId"));
  const [municipalityList, setMunicipalityList] = useState([]);
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [studentWise, setStudentWise] = useState([]);
  const [itemSizeSummary, setItemSizeSummary] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const today = new Date().toISOString().split("T")[0]; // "YY
  const [loadingReqQty, setLoadingReqQty] = useState(false);
  const [schoolList, setSchoolList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [TransportationList, setTransportationList] = useState([]);
  const [TransportationListItemWise, setTransportationListItemWise] = useState([]);
  const [showReportHeader, setShowReportHeader] = useState(false);
  const [sectionlList, setSectionList] = useState([]);
  const [shgList, setShgList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [showDeliveredModal, setShowDeliveredModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [deliveredData, setDeliveredData] = useState({
    delivery_date: new Date().toISOString().split("T")[0],
    delivery_remarks: ""
  });



    const handleDeliverySubmit = async () => {

    if (!deliveredData.delivery_date) {
        Swal.fire("Warning", "Please select delivery date", "warning");
        return;
    }

    const token = localStorage.getItem("token");

    const body = {
        delivery_date: deliveredData.delivery_date,
        id: selectedRow?.id,
        delivery_remarks: deliveredData.delivery_remarks
    };

    try {

        const response = await axios.post(
        `${BASE_URL}/doDeliveryByULB`,
        body,
        {
            headers: {
            Authorization: `Bearer ${token}`
            }
        }
        );

        if (response.data.status === true) {

        Swal.fire("Success", response.data.message, "success");

        setShowDeliveredModal(false);

        setDeliveredData({
            delivery_date: today,
            delivery_remarks: ""
        });

        fetchAssignedTransportationList(); // reload list

        } else {
        Swal.fire("Error", response.data.message, "error");
        }

    } catch (error) {

        handle401(error);

        Swal.fire(
        "Error",
        error?.response?.data?.message || "Something went wrong",
        "error"
        );

    }

    };

 const loadMunicipalityList = async () => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/municipalityList`,
      {},   // empty body
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.status) {
      setMunicipalityList(res.data.data || []);
    } else {
      setMunicipalityList([]);
    }

  } catch (e) {

    // ✅ redirect only on 401
    if (e?.response?.status === 401) {
      localStorage.clear();
              localStorage.clear();

      navigate("/suda/login");
      return;
    }

  }
};

  const handleViewDetails = async (deliveryId) => {
  try {
    setDetailsLoading(true);

const token = localStorage.getItem("token");

    console.log(deliveryId);

    const res = await axios.post(
      `${BASE_URL}/deliveryDataDetails`,
      { id: deliveryId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const row = res?.data?.data?.[0];

    setStudentWise(row?.student_wise || []);
    setItemSizeSummary(row?.item_size_summary || []);

    setShowDetailsModal(true);
  } catch (e) {
    console.log(e);
    handle401(e);   // ✅ keep consistent with your other APIs
  } finally {
    setDetailsLoading(false);
  }
};



   const loadShgList = async () => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorsList`,
      {
        vendor_type_id: "3"   // SHG
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (res.data.status === true) {
      setShgList(res.data.data || []);
    } else {
      setShgList([]);
    }

  } catch (err) {
    handle401(err);
  }
};

const fetchSectionList = async() =>{
      try{
      const token = localStorage.getItem("token");
          const response = await axios.get(`${BASE_URL}/sectionList`,

          { headers: { Authorization: `Bearer ${token}` } }
      )

      if(response.data.status === true){
          setSectionList(response.data.data.sectionList || []);
      }
      else{
          console.log("error sectionlist");
      }

      }catch(err){
         console.error("Student count error", err);
        if (handle401(err)) return;
      }
    }


    const loadMembers = async (shgId) => {
      try {
    const token = localStorage.getItem("token");

        const res = await axios.post(
          `${BASE_URL}/memberList`,
          {
            shg_id: shgId
          },
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        if (res.data.status === true) {
          setMemberList(res.data.data || []);
        } else {
          setMemberList([]);
        }

      } catch (err) {
        handle401(err);
      }
    };


  const fetchAssignedTransportationList = async (pageNumber = 1) => {

    if (userTypeId === 1 && !selectedMunicipality) {
  Swal.fire("Warning", "Please select municipality", "warning");
  return;}
    if (!filters.school_id) {
      Swal.fire("Warning", "Please select school", "warning");
      return;
    }

    try {
      setLoading(true);
  const token = localStorage.getItem("token");

const muniId =
  userTypeId === 1
    ? selectedMunicipality
    : localStorage.getItem("municipality_id");

      const payload = {
        municipality_id: muniId,
        school_id: filters.school_id,
        class_id: filters.class_id || "",
        vendor_id : filters.vendor_id || "",
        member_id : filters.member_id || "",
        is_delivered: filters.is_delivered || "",
        page: pageNumber.toString(),
        per_page: perPage.toString(),
      };

      const res = await axios.post(`${BASE_URL}/assignedTransportationList`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status) {
        setTransportationList(res.data.data || []);

        setTotalRecords(res.data.data.total || 0);
        setTotalPages(res.data.data.last_page || 1);
        setPage(pageNumber);
      } else {
        setTransportationList([]);
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (err) {
      handle401(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    if (isNaN(d)) return "-";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`; // DD/MM/YYYY
  };

  const loadSchools = async () => {
  try {
const token = localStorage.getItem("token");

    const municipalityId =
      userTypeId === 1
        ? selectedMunicipality
        : localStorage.getItem("municipality_id");

    // ✅ if userTypeId = 1 and municipality not selected yet, don't call API
    if (userTypeId === 1 && !municipalityId) {
      setSchoolList([]);
      return;
    }

    const payload = {
      municipality_id: municipalityId,
    };

    const res = await axios.post(
      `${BASE_URL}/schoolList`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setSchoolList(res.data.data || []);

  } catch (err) {
    handle401(err);
  }
};

  const loadClasses = async () => {
    try {
  const token = localStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/classList`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClassList(res.data.data.class_list || []);
    } catch (err) {
      handle401(err);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const selectedSchool = schoolList.find(
  (school) => school.id === Number(filters.school_id)
);

useEffect(() => {
  if (userTypeId === 1 && selectedMunicipality) {
    loadSchools(); // only call when a municipality is selected
  }
}, [selectedMunicipality]);

useEffect(() => {
  loadClasses();
  fetchSectionList();
  loadShgList();

  if (userTypeId === 1) {
    loadMunicipalityList(); // load municipality dropdown
  } else {
    // userTypeId 2 → can load schools immediately
    loadSchools();
  }
}, []);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* ================= FILTER CARD ================= */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter"></i> Assigned Transportation List
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">

            {userTypeId === 1 && (
  <Col md={3}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-semibold text-black">
        Municipality <span className="text-danger">*</span>
      </Form.Label>

      <Form.Select
        value={selectedMunicipality}
        onChange={(e) => setSelectedMunicipality(e.target.value)}
        style={{
          borderRadius: "10px",
          border: "2px solid #1565C1",
        }}
      >
        <option value="">Select Municipality</option>

        {municipalityList.map((m) => (
          <option key={m.user_id} value={m.user_id}>
            {m.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  </Col>
)}
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-black">
                  School <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={filters.school_id}
                  onChange={(e) =>
                    setFilters({ ...filters, school_id: e.target.value })
                  }
                  disabled={userTypeId === 1 && !selectedMunicipality}
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select School</option>

                  {schoolList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-black">
                  Class (Optional)
                </Form.Label>
                <Form.Select
                  value={filters.class_id}
                  onChange={(e) =>
                    setFilters({ ...filters, class_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select Class</option>

                  {classList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col> */}

            {userTypeId !== 1 && (
            <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    SHG (Optional)
                  </Form.Label>

                  <Form.Select
  value={filters.vendor_id}
  onChange={(e) => {
    const shgId = e.target.value;

    setFilters({
      ...filters,
      vendor_id: shgId,
      member_id: "",   // reset member
    });

    if (shgId) {
      loadMembers(shgId);
    } else {
      setMemberList([]);
    }
  }}
  style={{
    borderRadius: "10px",
    border: "2px solid #1565C1",
  }}
>
  <option value="">Select SHG</option>
  {shgList.map((shg) => (
    <option key={shg.id} value={shg.id}>
      {shg.vendors_master_name}
    </option>
  ))}
</Form.Select>
                </Form.Group>
              </Col>

)}

{userTypeId !== 1 && (

              <Col md={3}>
                 <Form.Group className="mb-3">
                   <Form.Label className="fw-bold">
                     Member (Optional)
                   </Form.Label>

                   <Form.Select
  value={filters.member_id}
  disabled={!filters.vendor_id}
  onChange={(e) =>
    setFilters({
      ...filters,
      member_id: e.target.value,
    })
  }
  style={{
    borderRadius: "10px",
    border: "2px solid #1565C1",
  }}
>
  <option value="">Select Member</option>
  {memberList.map((mem) => (
    <option key={mem.user_id} value={mem.user_id}>
      {mem.name}
    </option>
  ))}
</Form.Select>
                 </Form.Group>
               </Col>

)}

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Record Showing
                </Form.Label>

                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col><Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-black">
      Delivery Status (Optional)
    </Form.Label>

    <Form.Select
      value={filters.is_delivered}
      onChange={(e) =>
        setFilters({
          ...filters,
          is_delivered: e.target.value
        })
      }
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1"
      }}
    >
      <option value="">All</option>
      <option value="1">Delivered</option>
      <option value="0">Not Yet Delivered</option>
    </Form.Select>
  </Form.Group>
</Col>




             <Col md={2} className="mt-3">
              <Button
                className="w-100 fw-semibold text-white"
                style={{ background: "#1565C1", borderRadius: "10px" }}
                onClick={() => {
                  if (!filters.school_id) {
                    Swal.fire(
                      "Alert",
                      "Please select atleast one School",
                      "warning",
                    );
                    return;
                  }
                  setShowReportHeader(true);
                  fetchAssignedTransportationList();
                }}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>
            </Col>

            <Col md={2} className="mt-3">
              <Button
                className="w-100 fw-semibold text-white"
                style={{ background: "#E53935", borderRadius: "10px" }}
                onClick={() => {
      setFilters({
        school_id: "",
        class_id: "",
        vendor_id: "",
        member_id: "",
        is_delivered: ""
      });

      if (userTypeId === 1) {
        setSelectedMunicipality(""); // reset municipality for userTypeId 1
      }

      setShowReportHeader(false);
      setPage(1);
      setPerPage(10);
      setTransportationList([]);
      setTransportationListItemWise([]);
      setTotalRecords(0);
      setTotalPages(1);
      setMemberList([]);
      setShgList([]);
    }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>


          </Row>
        </Card.Body>
      </Card>


{showReportHeader && selectedSchool && (


    <div className="text-center mb-4">
          <h4 className="fw-bold text-dark mb-1">{selectedSchool.name}</h4>
          <div className="fs-6 text-success">
            School-wise Assigned Transportation List (till {today})
          </div>
    </div>

)}





      {/* ================= TABLE ================= */}

      <div className="mt-3">
        <Row>
          {TransportationListItemWise.map((item, index) => (
            <Col md={2} key={index} className="mb-3">
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2"
                style={{
                  background: "linear-gradient(135deg, #42A5F5, #1E88E5)",
                  borderRadius: "50px",
                  boxShadow: "0 4px 12px rgba(30,136,229,0.35)",
                  color: "#fff",
                }}
              >
                <div style={{ lineHeight: "1.2" }}>
                  <div style={{ fontSize: "16px", fontWeight: "600" }}>
                    {item.item_name}
                  </div>
                  <div style={{ fontSize: "16px", opacity: 0.9 }}>
                    Size: {item.size}
                  </div>
                </div>

                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {item.total_quantity}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="blue-spinner"></div>

          <div className="loading-line">
            <div className="loading-progress"></div>
          </div>

          <p className="loading-text">Loading, please wait...</p>
        </div>
      )}
      {!loading && (
        <Card
          className="mb-4 border-0"
          style={{
            background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
            boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          }}
        >
          <Table bordered hover responsive striped>
            <thead>
              <tr>
                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  SL
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Issue Date
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Challan Number
                </th>



                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Assigned SHG
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Member
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Status
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Details
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Action
                </th>






              </tr>
            </thead>
            <tbody>
              {!loading && TransportationList.length === 0 && (
                <tr>
                  <td colSpan="8" className="text-center text-muted">
                    No records found
                  </td>
                </tr>
              )}

              {TransportationList.map((row, index) => (
                <tr key={row.student_id}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{formatDate(row.issue_date)}</td>
                  <td className="text-center">{row.challan_no}</td>

                  {/* <td className="text-center">{row.school_name}</td> */}
                  <td className="text-center">{row.vendors_master_name}</td>
                  <td className="text-center">{row.member_names}</td>
                  <td className="text-center">
  {row.is_delivered === 1 ? (
    <span className="badge bg-success">
      Delivered
    </span>
  ) : (
    <span className="badge bg-warning text-dark">
      Assigned
    </span>
  )}
</td>

<td className="text-center">
  <i
    className="fa fa-eye text-primary"
    style={{ cursor: "pointer" }}
    onClick={() => handleViewDetails(row.id)}
  />
</td>

<td className="text-center">
  {row.is_delivered === 1 ? (
    <span className="badge bg-success">
      Delivered
    </span>
  ) : (
    <Button
      size="sm"
      style={{
        background: "#FFC107",
        border: "none",
        color: "#000",
        fontWeight: "600",
        borderRadius: "8px"
      }}
      onClick={() => {
        setSelectedRow(row);
        setShowDeliveredModal(true);
      }}
    >
      <i className="fa-solid fa-check me-1"></i>
      Mark as Delivered
    </Button>
  )}
</td>


                </tr>
              ))}
            </tbody>
          </Table>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <nav>
                <ul className="pagination shadow-sm">
                  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchAssignedTransportationList(1)}
                    >
                      «
                    </button>
                  </li>

                  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchAssignedTransportationList(page - 1)}
                    >
                      ‹
                    </button>
                  </li>

                  {getPageNumbers().map((p) => (
                    <li
                      key={p}
                      className={`page-item ${page === p ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => fetchAssignedTransportationList(p)}
                      >
                        {p}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      page === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchAssignedTransportationList(page + 1)}
                    >
                      ›
                    </button>
                  </li>

                  <li
                    className={`page-item ${
                      page === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchAssignedTransportationList(totalPages)}
                    >
                      »
                    </button>
                  </li>
                </ul>
              </nav>
            </div>


          )}

          <Modal
  show={showDetailsModal}
  onHide={() => setShowDetailsModal(false)}
  size="lg"
  centered backdrop="static"
  keyboard={false}
>
  <Modal.Header closeButton  backdrop="static"
  keyboard={false} style={{ background: "#3399ff", color: "white" }}>
    <Modal.Title>Transportation Details</Modal.Title>
  </Modal.Header>

  <Modal.Body>

    {/* ---------------- Student wise ---------------- */}
    <h5 className="mb-2 text-success">STUDENT ROLL No WISE DETAILS</h5>

    {detailsLoading ? (
      <div className="text-center">Loading...</div>
    ) : (
      studentWise.map((stu, idx) => (
        <div key={idx} className="border rounded p-2 mb-3">

          <div className="fw-semibold mb-1">
            Roll : {stu.roll_no} | {stu.class_name} | Section : {stu.section_name}
          </div>

          <Table bordered size="sm" className="mb-0 table-secondary">
            <thead>
              <tr>
                <th>Item</th>
                <th className="text-center">Size</th>
                <th className="text-center">Qty</th>
              </tr>
            </thead>
            <tbody>
              {stu.items.map((it, i) => (
                <tr key={i}>
                  <td>{it.item_name}</td>
                  <td className="text-center">{it.size}</td>
                  <td className="text-center">{it.quantity}</td>
                </tr>
              ))}
            </tbody>
          </Table>

        </div>
      ))
    )}

    {/* ---------------- Summary ---------------- */}
    <h5 className="mt-3 mb-2 text-success">ITEM DETAILS</h5>

    <Table bordered size="sm" className="table-secondary">
      <thead>
        <tr>
          <th>Item</th>
          <th className="text-center">Size</th>
          <th className="text-center">Total Qty</th>
        </tr>
      </thead>
      <tbody>
        {itemSizeSummary.map((s, i) => (
          <tr key={i}>
            <td>{s.item_name}</td>
            <td className="text-center">{s.size}</td>
            <td className="text-center">{s.total_quantity}</td>
          </tr>
        ))}
      </tbody>
    </Table>

  </Modal.Body>
</Modal>

<Modal
  show={showDeliveredModal}
  onHide={() => setShowDeliveredModal(false)}
  centered backdrop="static"
  keyboard={false}
>
  <Modal.Header closeButton style={{ background: "#3399ff", color: "white" }}>
    <Modal.Title>Mark as Delivered</Modal.Title>
  </Modal.Header>

  <Modal.Body>
  {/* Challan Header */}
  <div
    className="mb-4 p-3"
    style={{
      border: "2px dashed #999",
      borderRadius: "8px",
      background: "#fafafa"
    }}
  >
    <div className="text-center fw-bold mb-2" style={{ fontSize: "18px" }}>
      Delivery Challan Details
    </div>

    <table className="w-100">
      <tbody>
        <tr>
          <td style={{ width: "40%", fontWeight: "600" }}>Challan Number</td>
          <td style={{ width: "5%" }}>:</td>
          <td style={{ fontWeight: "500" }}>{selectedRow?.challan_no}</td>
        </tr>

        <tr>
          <td style={{ fontWeight: "600" }}>SHG Name</td>
          <td>:</td>
          <td style={{ fontWeight: "500" }}>{selectedRow?.vendors_master_name}</td>
        </tr>
      </tbody>
    </table>
  </div>
    <Form.Group className="mb-3">
      <Form.Label className="fw-semibold">
        Delivery Date <span className="text-danger">*</span>
      </Form.Label>



      <Form.Control
        type="date"
        value={deliveredData.delivery_date}
        onChange={(e) =>
          setDeliveredData({
            ...deliveredData,
            delivery_date: e.target.value
          })
        }
      />
    </Form.Group>

    <Form.Group>
      <Form.Label className="fw-semibold">
        Remarks (Optional)
      </Form.Label>

      <Form.Control
        as="textarea"
        rows={3}
        placeholder="Enter remarks"
        value={deliveredData.delivery_remarks}
        onChange={(e) =>
          setDeliveredData({
            ...deliveredData,
            delivery_remarks: e.target.value
          })
        }
      />
    </Form.Group>

  </Modal.Body>

  <Modal.Footer>

    <Button
      variant="secondary"
      onClick={() => setShowDeliveredModal(false)}
    >
      Cancel
    </Button>

    <Button
      style={{ background: "#1565C1", border: "none" }}
      onClick={handleDeliverySubmit}
    >
      Submit
    </Button>

  </Modal.Footer>
</Modal>
        </Card>


      )}
    </div>


  );
};

export default TransportationList;
